import { BaseService } from "./base-service";

export class LegacyBaseService extends BaseService {
  constructor(endpoint: string) {
    super(endpoint);
  }
}
